export default "__VITE_ASSET__CAM3igjm__"